<cmps-container variant="colored">
    <cmps-container-header [separator]="false">
        {{ _i18n._9401_SCORECARD_DETAIL | translate }}
    </cmps-container-header>
    <cmps-container-content>
        <div class="cmps-sw-detail--user-info">
            <div class="cmps-sw-detail--user-info--navigate">
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    (click)="_onPrevClick()"
                    *ngIf="!historyPosition?.isAtFirst"
                >
                    <cmps-icon svgIcon="scorecard:left-alt-2"></cmps-icon>
                </button>
            </div>
            <div class="cmps-sw-detail--user-info--detail">
                <div
                    class="sw-detail--search"
                    (click)="_onSearchUserClick()"
                >
                    <div class="cmps-sw-detail--search-icon">
                        <cmps-icon svgIcon="magnify"></cmps-icon>
                    </div>
                    <input
                        class="search-input"
                        [placeholder]="
                            _i18n._9409_SEARCH_FOR_OTHER_USERS | translate
                        "
                        disabled
                    />
                </div>
                <p>
                    <span
                        ><strong
                            >{{ _i18n._9410_USER_ | translate }}
                            {{ user?.firstName }} {{ user?.lastName }}</strong
                        ></span
                    >
                </p>
                <div class="sw-detail--periodtype-container">
                    <span class="sw-periodtype-title">{{
                        _i18n._9293_PERIOD_TYPE | translate
                    }}</span>
                    <ng-select
                        class="sw-select ml-3"
                        [options]="_periodTypes"
                        [ngModel]="_selectedPeriodType"
                        [noFilter]="999"
                        (focus)="_onPeriodTypeFocus()"
                        (ngModelChange)="_onPeriodTypeChange($event)"
                    >
                    </ng-select>
                </div>
                <p>
                    <span
                        >{{ _i18n._804_SUPERGROUP_ | translate }}
                        {{ scorecard?.header?.groupName }}</span
                    >
                </p>
                <p>
                    <span>
                        {{ _i18n._9411_FROM | translate }}
                        {{
                            scorecard?.header?.startDate | cmpsDate: 'LLL-dd-y'
                        }}
                        {{ _i18n._9253_TO | translate }}
                        {{ scorecard?.header?.endDate | cmpsDate: 'LLL-dd-y' }}
                    </span>
                </p>
                <p>
                    <span
                        >{{ _i18n._9412_SCORECARD_ | translate }}
                        {{ scorecard?.header?.scorecardId }}</span
                    >
                </p>
            </div>
            <div class="cmps-sw-detail--user-info--navigate">
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    (click)="_onNextClick()"
                    *ngIf="!historyPosition?.isAtLast"
                >
                    <cmps-icon svgIcon="scorecard:right-alt-2"></cmps-icon>
                </button>
            </div>
        </div>
    </cmps-container-content>
</cmps-container>
